<template>
    <div class="container">
      <!-- 判断 appointments 是否为空 -->
      <div v-if="appointments.length === 0" class="no-data">
        <span>无表单申请</span>
      </div>
  
      <!-- 遍历 appointments 数据，渲染每个预约项 -->
      <div
        v-for="(item, index) in appointments"
        :key="index"
        class="appointment-item"
      >
        <div class="appointment-header">
          <span class="name">{{ item.name }}</span>
          <span class="phone-number">{{ item.phone }}</span>
          <span class="status">{{ item.zhuangTai }}</span>
        </div>
        <div class="divider"></div>
        <div class="appointment-time">
          <span>拜访者名字: {{ item.name }}</span>
          <span>到访原因: {{ item.reason }}</span>
          <span>到访人数: {{ item.daofangNumber }}</span>
          <span>拜访时间: {{ item.readTime }}</span>
          <span v-if="item.zhuangTai==='审批不通过'">不通过原因: {{ item.errReason }}</span>
          <span v-if="item.zhuangTai==='审批通过' || item.zhuangTai==='未进入'">访客数字码: {{ item.fangkeNumber }}</span>
          <span v-if="(item.qrCode!='已使用' && item.zhuangTai==='审批通过') || item.zhuangTai==='未进入'" >访客二维码：</span>
          <div class="qr-code">
            <img v-if="(item.qrCode!='已使用' && item.zhuangTai==='审批通过') || item.zhuangTai==='未进入'" :src="'data:image/png;base64,' + item.qrCode">
          </div>
          <span v-if="item.qrCode !== '已使用' && item.zhuangTai==='审批通过'">长按二维码进行转发</span>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "AppointmentList",
    data() {
      return {
        appointments: [], // 初始为空，通过 API 获取数据
        
      };
    },
    created() {
      this.fetchAppointments(); // 在组件创建时调用 API 获取数据
    },
    methods: {
      fetchAppointments() {
        // 调用 API 获取 appointments 数据
        this.$axios.get("/api/chaxun_qiye_form") // 假设 API 地址为 /api/chaxun_fangke_form
          .then(response => {
            this.appointments = response.data.data.map(item => {
              console.log(response.data.data)
                //替换T
                if(item.readTime){
                    item.readTime = item.readTime.replace('T',' ');
                    
                }
                console.log(this.appointments.length)
                return item;
            }).reverse(); // 假设返回的数据是一个数组
          })
          .catch(error => {
            console.error("Error fetching appointments:", error);
            this.$message.error("加载预约信息失败，请稍后再试");
          });
      },
      
    }
  };
  </script>

<style scoped>
.container {
  padding: 16px;
  background-color: #ffffff; /* 页面背景为白色 */
  height: 100%;
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 16px;
}

.appointment-item {
  background-color: #ffffff; /* 框背景为白色 */
  border: 1px solid #fff; /* 框边框为蓝色 */
  border-radius:10px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 10px 10px 10px rgba(0, 123, 255, 0.1); /* 添加阴影效果 */
  cursor: default; /* 默认不可点击 */
}

.appointment-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.appointment-header .name {
  font-weight: bold;
  font-size: 18px;
}

.appointment-header .phone-number {
  color: #007bff;
}

.appointment-header .status {
  color: #5cb85c;
}

.divider {
  border-bottom: 1px solid #ddd;
  margin-bottom: 12px;
}

.appointment-time span {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.qr-code img {
  max-width: 100px;
  margin-top: 8px;
}
</style>